module.exports = __webpack_public_path__ + "b9ec45e42d739ab0fe75671aee85df9c.svg";